import { useEffect } from "react";

import { useBlizzardEvents, useEntryPoint } from "../../analytics/hooks";

export const useLensManagementPageOpenBlizzardEvent = (): void => {
    const { sendBlizzardEvent } = useBlizzardEvents();
    const { defineEntryPoint } = useEntryPoint();

    useEffect(() => {
        sendBlizzardEvent({
            event: "MYLENSES_MANAGEMENT_PAGE_OPEN",
            entryPoint: defineEntryPoint,
        });
    }, [sendBlizzardEvent, defineEntryPoint]);
};
